import {
  IQueryOptionsByFieldIdWhere,
  IQueryOptionsByFieldIdOrderBy,
  MakeQueryOptionsDtoArgs,
} from '@global/api/types/queryOptions'

export interface State {
  commitRef: string
  datasetRowCount: number
  datasetLoading: boolean
  limit: number
  offset: number
  showHiddenColumns: boolean
  queryOptionsByFieldId: MakeQueryOptionsDtoArgs['optionsByFieldId']
  queryRowCountIsLoading: boolean
  queryRowCount: number
  updatingFilters: boolean
}

interface DatasetQueryContextActions {
  addFilter: (filterIndex: number, newFilter: any) => any
  appendFilter: (filter: any) => void
  clearQueryOptionsByFieldId: (fieldId: string) => void
  getAllDatasetData: (arg: { dsId: any }) => Promise<any>
  getDatasetId: () => null | string
  getFiltersByFieldId: (fieldId: string) => any
  getQueryOptionsByFieldId: (fieldId: string) => any
  getSearchTermByFieldId: (fieldId: string) => string
  getSortOrderByFieldId: (fieldId: string) => any
  hasFilterWithOperator: (fieldId: string, operator: any) => boolean
  hasQueryOptions: (fieldId: string) => boolean
  makeQueryOptionsDto: (queryOptions: any) => any
  refetchDataset: () => void
  removeFilterByFieldId: (fieldId: string, filterIndex: number) => void
  setCommitRef: (val: string) => void
  setDatasetLoading: (bool: boolean) => void
  setOffsetDebounced: (newOffset: number) => void
  setQueryOptionsByFieldId: (
    nextQueryOptionsByFieldId: IQueryOptionsByFieldIdOrderBy | IQueryOptionsByFieldIdWhere,
  ) => void
  updateFilterOperatorByFieldId: (fieldId: string, filterIndex: number, filterOperator: any) => void
  updateFiltersByFieldId: (fieldId: string, filters: any) => void
  updateFilterValueByFieldId: (fieldId: string, filterIndex: number, filterValue: any) => void
  updateQueryOptionsByFieldId: (
    fieldId: string | null,
    queryOptions: any,
  ) => Record<string, Record<string, unknown>>
  updateShowHiddenFields: (showHiddenFields: boolean) => void
  updateSortOrderByFieldId: (fieldId: string, sortOrder: any) => void
  updateUrlParams: (queryOptions: any) => void
}

export type DatasetQueryContextType = Omit<State, 'reducerDispatch'> & DatasetQueryContextActions

export enum ActionType {
  setCommitRef = 'setCommitRef',
  setDatasetData = 'setDatasetData',
  setDatasetLoading = 'setDatasetLoading',
  setOffset = 'setOffset',
  setShowHiddenColumns = 'setShowHiddenColumns',
  setUpdatingFilters = 'setUpdatingFilters',
  setQueryRowCount = 'setQueryRowCount',
}

export type Action =
  | {
      type: 'setDatasetData'
      payload: {
        commitRef: string
        queryRowCountIsLoading: boolean
        queryRowCount: number
        datasetRowCount: number
        datasetLoading: boolean
        updatingFilters: boolean
      }
    }
  | { type: 'setCommitRef'; payload: string }
  | { type: 'setDatasetLoading'; payload: boolean }
  | { type: 'setOffset'; payload: number }
  | { type: 'setUpdatingFilters'; payload: boolean }
  | { type: 'setShowHiddenColumns'; payload: boolean }
  | { type: 'resetFilters' }
  | {
      type: 'setQueryOptions'
      payload: IQueryOptionsByFieldIdOrderBy | IQueryOptionsByFieldIdWhere
    }
  | { type: 'setQueryRowCount'; payload: number }
